
import React from 'react';

const Contact: React.FC = () => {
  return (
    <section id="contact" className="py-20 relative">
      <div className="absolute inset-0 bg-circuit-pattern opacity-5"></div>
      
      <div className="container mx-auto px-4">
        <h2 className="text-3xl md:text-4xl font-pixel mb-8 inline-block relative">
          <span className="text-shadow-glow">{'\u003E'} Contact</span>
          <span className="absolute -bottom-2 left-0 w-full h-0.5 bg-cyber-green"></span>
        </h2>
        
        <div className="max-w-3xl mx-auto">
          <div className="cyber-box">
            <span></span>
            <div className="p-8 text-center">
              <p className="text-xl md:text-2xl font-cyber mb-6">Connect with SpecialAgentK</p>
              
              <div className="flex flex-col md:flex-row justify-center items-center gap-8 mt-4">
                <div className="flex items-center space-x-3">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-cyber-green" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                  </svg>
                  <a href="mailto:specialagentk403@gmail.com" className="text-lg hover:text-cyber-green transition-colors">
                    specialagentk403@gmail.com
                  </a>
                </div>
                
                <div className="flex items-center space-x-3">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-cyber-green" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                  </svg>
                  <a href="https://twitter.com/SAK1337" target="_blank" rel="noopener noreferrer" className="text-lg hover:text-cyber-green transition-colors">
                    @SAK1337
                  </a>
                </div>
              </div>
            </div>
            <span></span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
